import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const paramsSchema = z.object({
  viewId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/view/$viewId')({
  params: paramsSchema,
});
